import React, { useCallback } from 'react'
import { useMemo } from 'react'
import { useAddressesQuery } from '../../../../api/options/hooks'
import { ObjectDescriptionHelper } from '../constants'
import { Step2FormOptionsProps, Step2FormProps } from '../types'

const useStep2FormOptions = (form: Step2FormProps['form']): Step2FormOptionsProps => {
    const zipCode = form.watch('objectZIP')
    const objectType = form.watch('objectType')
    const [zipCodeSearch, setZipCodeSearch] = React.useState<string | undefined>(zipCode)
    const handleZipCodeSearchChanged = useCallback((zip: string) => setZipCodeSearch(zip), [])

    const {
        data: addresses,
        error: zipCodeSearchError,
        isLoading: zipCodeSearchLoading,
    } = useAddressesQuery(zipCodeSearch?.replace(' ', ''))
    const { data: citiesData, error: citiesError, isLoading: citiesLoading } = useAddressesQuery(zipCode)

    const zipCodes = useMemo(() => {
        if (addresses)
            return addresses.map((adr) => {
                return { value: adr.zip, label: adr.zip }
            })
        return []
    }, [addresses])

    const cities = useMemo(() => {
        if (zipCode && citiesData && citiesData.length > 0) return citiesData[0].cities
        return undefined
    }, [citiesData, zipCode])

    return {
        zipCodes,
        zipCodeSearch,
        handleZipCodeSearchChanged,
        cities,
        objectDescriptionHelper: objectType ? ObjectDescriptionHelper[objectType] : undefined,
        error: zipCodeSearchError?.detail || citiesError?.detail,
        isLoading: zipCodeSearchLoading || citiesLoading,
    }
}

export default useStep2FormOptions
